import React from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import OrderProductForm from '@views/dashboard/production/OrderProductForm';
import ProductionDashboard from '@views/dashboard/ProductionDashboard';
import getUri from '@src/helpers/getUri';
import cacheableAccessor from '@src/helpers/cacheableAccessor';
import {EndpointUri} from '@src/@types/EndpointUri';
import BreadcrumbsManager from '@views/dashboard/BreadcrumbsManager';
import OrderProductsList from '@views/dashboard/production/OrderProductsList';
import {useParams} from 'react-router-dom';

const getPageBreadcrumbs = cacheableAccessor(() => [
    {
        label: ProductionDashboard.pageTitle,
        uri: getUri('dashboards@production'),
    },
    {
        label: OrderProductsListFilteredByProductId.pageTitle,
        uri: {route: 'dashboards@production-by-product-id'} as EndpointUri,
    }
]);

function Content(props: Omit<React.ComponentProps<typeof BreadcrumbsManager>, 'children'>) {
    const {productId} = useParams<{ productId?: string }>() ?? {};
    if (!productId) {
        return null;
    }

    return <BreadcrumbsManager {...props}>
        <OrderProductsList
                chosenFilterName="filter-by-product-id"
                disabledColumns={['product']}
                forceColumnsValues={{'product': productId}}
                uniqueListName="order-products-list-with-the-same-product-id"
                defaultDisplayFilters
                dontChangeUserPreferences
        />
    </BreadcrumbsManager>;
}

export default class OrderProductsListFilteredByProductId extends AbstractView {
    static pageTitle = 'Dashboards:Production.order-products-list-filtered-by-product-id.page-title';

    protected renderContent() {
        return <Content
                pageTitle={this.getPageTitle()}
                pageBreadcrumbs={this.getPageBreadcrumbs()}
        />;
    }

    protected getPageBreadcrumbs(): React.ComponentProps<typeof OrderProductForm>['pageBreadcrumbs'] {
        return getPageBreadcrumbs();
    }
}
